<div class="pci" [class.pci--invalid]="invalid" data-test="pci">
    <input
        *ngFor="let i of indexes"
        #box
        class="pci__box ph-no-capture"
        type="text"
        inputmode="numeric"
        pattern="[0-9]*"
        [attr.autocomplete]="i === 0 ? 'one-time-code' : 'off'"
        [attr.aria-label]="copy.digitLabel(i + 1)"
        [attr.aria-invalid]="invalid ? 'true' : null"
        [attr.aria-describedby]="describedBy"
        [disabled]="disabled"
        [value]="digits[i]"
        (keydown)="onKeyDown($event, i)"
        (input)="onInput($event, i)"
        (paste)="onPaste($event)"
        data-test="pci-box"
    />
</div>
